import React from "react";
import { SvgIcon } from "../../../src/index";
var compPaths = {
  s: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M14 5.813L5.224 9.534c-.73.31-1.345.465-1.84.465-.558 0-.964-.197-1.213-.59-.323-.505-.182-1.32.373-2.18.329-.504.748-.965 1.156-1.406-.096.156-.944 1.566-.017 2.23.183.133.444.198.765.198.257 0 .552-.042.877-.126L14 5.813z",
    clipRule: "evenodd"
  })),
  m: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M21 8.719L7.836 14.303c-1.096.465-2.018.697-2.76.697-.837 0-1.446-.295-1.82-.884-.485-.76-.273-1.982.56-3.272.493-.754 1.121-1.446 1.733-2.108-.144.234-1.415 2.349-.025 3.345.275.2.666.298 1.147.298.386 0 .83-.063 1.316-.19l13.014-3.47z",
    clipRule: "evenodd"
  })),
  l: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M42 17.438L15.672 28.605c-2.192.93-4.036 1.393-5.522 1.393-1.672 0-2.89-.59-3.638-1.767-.97-1.518-.546-3.965 1.118-6.544.988-1.508 2.244-2.892 3.468-4.216-.288.467-2.83 4.697-.05 6.69.55.4 1.332.596 2.294.596.772 0 1.658-.127 2.632-.38L42 17.438z",
    clipRule: "evenodd"
  }))
};
export var NikeApp = /*#__PURE__*/React.memo(function (props) {
  return /*#__PURE__*/React.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths,
    fill: "none"
  }));
});